import Option from '../select/option.vue';

export default Option;


//////////////////
// WEBPACK FOOTER
// ./~/iview/src/components/option/index.js
// module id = 361
// module chunks = 1